import { render, staticRenderFns } from "./BaseLayoutModifier.vue?vue&type=template&id=744db282"
import script from "./BaseLayoutModifier.vue?vue&type=script&lang=js"
export * from "./BaseLayoutModifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744db282')) {
      api.createRecord('744db282', component.options)
    } else {
      api.reload('744db282', component.options)
    }
    module.hot.accept("./BaseLayoutModifier.vue?vue&type=template&id=744db282", function () {
      api.rerender('744db282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseLayoutModifier.vue"
export default component.exports